/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import { useSelector } from 'react-redux';

import { useAction } from '../../../Common/hooks';
import { getCurrentSelectedRejected } from '../../selectors';
import { setCurrentRejectedsDetails } from '../../actions';
import { getRejectedDetails } from '../../services';

const useRejectedTabs = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { rejectedId } = useSelector(getCurrentSelectedRejected);
  const dispatchRejectedDetailsInfo = useAction(setCurrentRejectedsDetails);

  const saveRejectedDetails = async () => {
    const response = await getRejectedDetails(rejectedId);

    dispatchRejectedDetailsInfo(response);
    setIsLoading(false);
  };

  return { saveRejectedDetails, isLoading };
};

export default useRejectedTabs;
